import React from "react";

import { sqlDateToHumanDate, getPropInSubLevelRole, safeValue } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const SupplierData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Supplier'
                stateContent={stateData.supplier_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Alamat'
                stateContent={stateData.supplier_address ? stateData.supplier_address : '-'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Kontak'
                stateContent={stateData.supplier_contact ? stateData.supplier_contact : '-'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Keterangan'
                stateContent={stateData.supplier_info ? stateData.supplier_info : '-'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.supplier_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.supplier_created_datetime,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diinput Oleh'
                stateContent={safeValue(stateData.supplier_created_user_name, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInSubLevelRole(stateData.supplier_created_user_sub_level, 'caption', '-')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default SupplierData;